import axios from "axios";
import { server } from "../api";

const IndoorPositioning = {
  GetIndoorPositioning: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取室內定位設定失敗",
        }
      );
    }
  },

  UploadFloorImage: async (file, machineID) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/floor-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "圖片上傳失敗",
        }
      );
    }
  },

  UpdateIndoorPositioning: async (machineID, payload) => {
    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}`,
        payload
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新室內定位設定失敗",
        }
      );
    }
  },

  DeleteFloorImage: async (machineID) => {
    try {
      const response = await axios.delete(
        `${server}indoor-positioning/${machineID}/floor-image`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "刪除平面圖影像失敗",
        }
      );
    }
  },

  GetSiblingMachines: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/siblings`
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取同場域機器列表失敗",
        }
      );
    }
  },
};

export default IndoorPositioning;
